import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";
export const getTasks = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token?.success && token.data){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/tasks`; 
            console.log('tasks endpoint', endpoint);
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};

export const getTask = async (organization_id: any, task_id:any) => {
  let token = await getAuthToken();
  try {
      if(token?.success && token.data){
          let header_token = "Bearer " + token.data;
          const headers = {
              Authorization: header_token,
          };
      try {
          const endpoint = `${baseUrl}/core/organizations/${organization_id}/tasks/${task_id}`; 
          const response = await axios.get(endpoint,{ headers });
          if (response.status>=200 && response.status <=400) {
          return {"success":true, "data": response?.data};
          } else {
          console.error("Data retrieval failed here:", response, response.data);
          return {"success":false, "data": response?.data};
          }
      } catch (error) {
          console.error("An unexpected error occurred:", error);
          return {"success":false, "data": error};
      }
      }else{
      return {"success":false, "data": "error: Token does not exist"};
      }
      
  }catch (error) {
      console.error("Unexpected error occurred while fetching the leads:", error);
      return {"success":false, "data": undefined};
  }
};

export const saveTask = async (
  orgId: string,
  title: string,
  description: string,
  start_date: string,
  due_date: string,
  priority: string,
  status: string,
  assigned_to: string | null,
  remarks: string
) => {
  const taskData = {
    title,
    description,
    start_date,
    due_date,
    priority,
    status,
    assigned_to,
    remarks,
  };

  let token = await getAuthToken();
  let headers;

  if(token?.success && token.data){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/tasks/`;
    const response = await axios.post(endpoint, taskData, {headers});

    if (response.status === 201) {
      console.log("Task created successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to create lead:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateTaskDetail = async (
  orgId: string,
  taskId:any,
  detailName: string,
  detailData: string,
) => {

  const taskData = {
    [detailName]: detailData
  };

  console.log('data', taskData);
  let token = await getAuthToken();
  let headers;

  if(token?.success && token.data){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/tasks/${taskId}/`;
    const response = await axios.patch(endpoint, taskData, {headers});

    if (response.status === 200) {
      console.log("Task data updated successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to update task:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateTaskDetails = async (
  orgId: string,
  taskId:any,
  detailData: any,
) => {

  const taskData = detailData;

  // console.log('data', taskData);
  let token = await getAuthToken();
  let headers;

  if(token?.success && token.data){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/tasks/${taskId}/`;
    const response = await axios.patch(endpoint, taskData, {headers});

    if (response.status === 200) {
      console.log("Task data updated successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to update task:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const deleteTask = async (orgId: string, taskId: string) => {
    let token = await getAuthToken();
    let headers;

    if(token?.success && token.data){
      let header_token = "Bearer " + token.data;
      headers = {
          Authorization: header_token,
      };
    }

    try {
      const endpoint = `${baseUrl}/core/organizations/${orgId}/tasks/${taskId}/`;
      const response = await axios.delete(endpoint, {headers});
  
      if (response.status === 204) {
        console.log("Task deleted successfully");
        return { success: true, data: "Task deleted successfully" };
      } else {
        console.warn("Unexpected response status:", response.status);
        return { success: false, data: response.data };
      }
    } catch (error: any) {
      console.error("Error deleting task:", error?.response?.data || error);
      return { success: false, data: error?.response?.data || error };
    }
  };
